<template>
  <div class="cost-diff-rule-add">
    <div class="page-header">
      <div class="header-left">
        <el-button icon="el-icon-arrow-left" @click="goBack">返回</el-button>
        <span class="page-title">新增差异规则</span>
      </div>
    </div>

    <div class="form-container">
      <div class="form-section">
        <div class="section-header" @click="toggleSection('basic')">
          <span class="section-icon">▎</span>
          <span class="section-title">基本信息</span>
          <span class="section-toggle">{{ sections.basic ? '收起' : '展开' }}</span>
        </div>
        <div class="section-content" v-show="sections.basic">
          <el-form :model="ruleForm" label-width="120px" class="form-grid">
            <el-form-item label="规则编号">
              <el-input
                v-model="ruleForm.ruleCode"
                placeholder="系统自动生成"
                disabled
                class="disabled-input"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <span class="required-mark">* </span>差异原因
              </span>
              <el-select v-model="ruleForm.diffCategory" placeholder="请选择">
                <el-option label="结算系统不存在" value="结算系统不存在" />
                <el-option label="红冲运单" value="红冲运单" />
                <el-option label="物流商不存在" value="物流商不存在" />
                <el-option label="非宝尊月结" value="非宝尊月结" />
                <el-option label="退货运单无批次号" value="退货运单无批次号" />
                <el-option label="退货运单仅登记" value="退货运单仅登记" />
                <el-option label="运单接口不存在" value="运单接口不存在" />
                <el-option label="运费未正常计算" value="运费未正常计算" />
                <el-option label="月结账号差异" value="月结账号差异" />
                <el-option label="产品类型差异" value="产品类型差异" />
                <el-option label="运单卡接口" value="运单卡接口" />
                <el-option label="目的地省差异" value="目的地省差异" />
                <el-option label="计费重量差异" value="计费重量差异" />
                <el-option label="首重报价差异" value="首重报价差异" />
                <el-option label="续重报价差异" value="续重报价差异" />
                <el-option label="折后运费差异" value="折后运费差异" />
                <el-option label="标准运费差异" value="标准运费差异" />
                <el-option label="服务费差异" value="服务费差异" />
                <el-option label="逆向月结一口价差异" value="逆向月结一口价差异" />
              </el-select>
            </el-form-item>
            <el-form-item label="启用状态">
              <el-radio-group v-model="ruleForm.status">
                <el-radio label="启用" />
                <el-radio label="禁用" />
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="form-section">
        <div class="section-header" @click="toggleSection('handler')">
          <span class="section-icon">▎</span>
          <span class="section-title">处理指派</span>
          <span class="section-toggle">{{ sections.handler ? '收起' : '展开' }}</span>
        </div>
        <div class="section-content" v-show="sections.handler">
          <el-form :model="ruleForm" label-width="120px">
            <el-form-item>
              <span slot="label">
                <span class="required-mark">* </span>处理方
              </span>
              <el-select
                v-model="ruleForm.handlerRole"
                placeholder="请选择"
                @change="handleHandlerRoleChange"
              >
                <el-option label="物流商" value="物流商" />
                <el-option label="财务" value="财务" />
                <el-option label="IT" value="IT" />
                <el-option label="配送组" value="配送组" />
                <el-option label="KA" value="KA" />
                <el-option label="运营" value="运营" />
              </el-select>
            </el-form-item>
          </el-form>

          <template v-if="ruleForm.handlerRole === '物流商'">
            <div class="carrier-config-section">
              <div class="config-title">物流商处理人配置（物流商编码与快递公司名称至少填一个）</div>
              <el-table
                :data="carrierHandlers"
                border
                :fit="true"
                style="width: 100%; margin-bottom: 10px;"
              >
                <el-table-column prop="carrierCode" label="物流商编码" min-width="120">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.carrierCode" placeholder="SF、JD等" style="width: 100%;" />
                  </template>
                </el-table-column>
                <el-table-column prop="expressName" label="快递公司名称" min-width="150">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.expressName" placeholder="顺丰速运等" style="width: 100%;" />
                  </template>
                </el-table-column>
                <el-table-column prop="handler" label="处理人" min-width="140">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.handler" placeholder="请选择" style="width: 100%;">
                      <el-option v-for="user in userOptions" :key="user" :label="user" :value="user" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button type="text" @click="removeCarrierHandler(scope.$index)" :disabled="carrierHandlers.length <= 1">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="text" @click="addCarrierHandler">+ 新增一行</el-button>
            </div>
          </template>

          <template v-else-if="ruleForm.handlerRole === 'KA'">
            <div class="ka-config-section">
              <div class="config-header">
                <div class="config-title">KA处理人配置</div>
                <div class="config-actions">
                  <el-dropdown trigger="click">
                    <el-button type="text" icon="el-icon-upload">导入<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="importKaConfig">导入Excel</el-dropdown-item>
                      <el-dropdown-item @click.native="downloadKaTemplate">下载模板</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-button type="text" icon="el-icon-download" @click="exportKaConfig">导出</el-button>
                  <el-button 
                    type="text" 
                    icon="el-icon-delete" 
                    @click="batchDeleteKaHandlers"
                    :disabled="selectedKaHandlers.length === 0"
                    class="batch-delete-btn"
                  >批量删除</el-button>
                </div>
              </div>
              <el-table
                :data="kaHandlers"
                border
                :fit="true"
                style="width: 100%; margin-bottom: 10px;"
                :selectable="(row, index) => kaHandlers.length > 1"
                @selection-change="handleKaSelectionChange"
              >
                <el-table-column type="selection" width="55" />
                <el-table-column prop="brandName" min-width="150">
                  <template slot="header">
                    <span class="required-mark">* </span>品牌名称
                  </template>
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.brandName"
                      multiple
                      placeholder="请选择品牌"
                      style="width: 100%;"
                      @change="handleBrandChange(scope.$index, scope.row.brandName)"
                    >
                      <el-option v-for="brand in brandOptions" :key="brand" :label="brand" :value="brand" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="handler" min-width="140">
                  <template slot="header">
                    <span class="required-mark">* </span>处理人
                  </template>
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.handlers"
                      multiple
                      placeholder="请选择处理人"
                      style="width: 100%;"
                    >
                      <el-option v-for="user in scope.row.availableHandlers" :key="user" :label="user" :value="user" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button type="text" @click="removeKaHandler(scope.$index)" :disabled="kaHandlers.length <= 1">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="text" @click="addKaHandler">+ 新增一行</el-button>
              <input type="file" ref="kaImportFile" style="display: none;" accept=".xlsx,.xls" @change="handleKaImport" />
            </div>
          </template>

          <template v-else>
            <el-form :model="ruleForm" label-width="120px">
              <el-form-item>
                <span slot="label">
                  <span class="required-mark">* </span>处理人
                </span>
                <el-select
                  v-model="ruleForm.handlers"
                  multiple
                  placeholder="请选择处理人"
                  style="width: 250px;"
                >
                  <el-option v-for="user in userOptions" :key="user" :label="user" :value="user" />
                </el-select>
              </el-form-item>
            </el-form>
          </template>
        </div>
      </div>

      <div class="form-section">
        <div class="section-header" @click="toggleSection('condition')">
          <span class="section-icon">▎</span>
          <span class="section-title">判定条件</span>
          <span class="section-toggle">{{ sections.condition ? '收起' : '展开' }}</span>
        </div>
        <div class="section-content" v-show="sections.condition">
          <div v-if="ruleForm.conditions.length === 0" class="empty-condition">
            <el-button type="text" icon="el-icon-plus" @click="addCondition">+ 新增条件</el-button>
            <span>（可选，可不配置判定条件）</span>
          </div>
          <div v-else>
            <div v-for="(condition, index) in ruleForm.conditions" :key="index" class="condition-row">
              <el-select v-model="condition.field" placeholder="选择字段" class="condition-field">
                <el-option label="物流商计费重量" value="logisticsChargeWeight" />
                <el-option label="BZ_计费重量" value="bzChargeWeight" />
                <el-option label="物流商标准运费" value="logisticsStandardFreight" />
                <el-option label="BZ_系统标准运费" value="bzStandardFreight" />
                <el-option label="物流商折后运费" value="logisticsDiscountedFreight" />
                <el-option label="BZ_系统折后运费" value="bzDiscountedFreight" />
                <el-option label="物流商总费用" value="logisticsTotalCost" />
                <el-option label="BZ_系统总费用" value="bzTotalCost" />
                <el-option label="物流商服务费" value="logisticsServiceFee" />
                <el-option label="BZ_系统服务费" value="bzServiceFee" />
                <el-option label="物流商计费重量-BZ_计费重量" value="logisticsMinusBzChargeWeight" />
                <el-option label="BZ_计费重量-物流商计费重量" value="bzMinusLogisticsChargeWeight" />
              </el-select>
              <el-select v-model="condition.operator" placeholder="选择操作符" class="condition-operator">
                <el-option label="大于" value="greaterThan" />
                <el-option label="小于" value="lessThan" />
                <el-option label="等于" value="equals" />
                <el-option label="不等于" value="notEquals" />
              </el-select>
              <el-select v-model="condition.valueType" placeholder="选择类型" class="condition-value-type">
                <el-option label="字段" value="field" />
                <el-option label="值" value="value" />
              </el-select>
              <template v-if="condition.valueType === 'field'">
                <el-select v-model="condition.value" placeholder="选择字段" class="condition-value">
                  <el-option label="物流商计费重量" value="logisticsChargeWeight" />
                  <el-option label="BZ_计费重量" value="bzChargeWeight" />
                  <el-option label="物流商标准运费" value="logisticsStandardFreight" />
                  <el-option label="BZ_系统标准运费" value="bzStandardFreight" />
                  <el-option label="物流商折后运费" value="logisticsDiscountedFreight" />
                  <el-option label="BZ_系统折后运费" value="bzDiscountedFreight" />
                  <el-option label="物流商总费用" value="logisticsTotalCost" />
                  <el-option label="BZ_系统总费用" value="bzTotalCost" />
                  <el-option label="物流商服务费" value="logisticsServiceFee" />
                  <el-option label="BZ_系统服务费" value="bzServiceFee" />
                  <el-option label="物流商计费重量-BZ_计费重量" value="logisticsMinusBzChargeWeight" />
                  <el-option label="BZ_计费重量-物流商计费重量" value="bzMinusLogisticsChargeWeight" />
                </el-select>
              </template>
              <template v-else>
                <el-input v-model="condition.value" placeholder="输入值" class="condition-value" />
              </template>
              <el-select
                v-model="condition.logic"
                placeholder="逻辑"
                class="condition-logic"
                v-if="index < ruleForm.conditions.length - 1"
              >
                <el-option label="AND" value="AND" />
                <el-option label="OR" value="OR" />
              </el-select>
              <el-button type="text" icon="el-icon-delete" @click="removeCondition(index)">删除</el-button>
            </div>
            <el-button type="text" icon="el-icon-plus" @click="addCondition" style="margin-top: 10px;">+ 新增条件</el-button>
            <div class="condition-preview">
              <span class="preview-label">逻辑关系预览：</span>
              <span class="preview-content">{{ conditionPreview }}</span>
            </div>
          </div>
        </div>
      </div>

      

      <div class="form-section">
        <div class="section-header" @click="toggleSection('supplement')">
          <span class="section-icon">▎</span>
          <span class="section-title">补充信息</span>
          <span class="section-toggle">{{ sections.supplement ? '收起' : '展开' }}</span>
        </div>
        <div class="section-content" v-show="sections.supplement">
          <el-form :model="ruleForm" label-width="120px" class="form-grid">
            <el-form-item>
              <span slot="label">
                <span class="required-mark">* </span>优先级
              </span>
              <el-input type="number" v-model="ruleForm.priority" placeholder="正整数" style="width: 100px;" />
            </el-form-item>
            <el-form-item label="判定逻辑描述">
              <el-input
                type="textarea"
                v-model="ruleForm.conditionSummary"
                placeholder="系统自动生成，可手动修改"
                :rows="3"
                style="width: 400px;"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="form-section">
        <div class="section-header" @click="toggleSection('cc')">
          <span class="section-icon">▎</span>
          <span class="section-title">抄送方配置</span>
          <span class="section-toggle">{{ sections.cc ? '收起' : '展开' }}</span>
        </div>
        <div class="section-content" v-show="sections.cc">
          <el-form :model="ruleForm" label-width="120px" class="form-grid">
            <el-form-item label="抄送方">
              <el-select
                v-model="ruleForm.ccHandlers"
                multiple
                filterable
                placeholder="请选择抄送人（可选，支持多选）"
                style="width: 300px;"
              >
                <el-option v-for="user in userOptions" :key="user" :label="user" :value="user" />
              </el-select>
              <div class="cc-hint">
                <span>说明：抄送方可查看差异详情并反馈意见，反馈结果仅供参考，不影响审核流程，不限制反馈时间。</span>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <div class="form-footer">
      <div class="footer-buttons">
        <el-button @click="goBack">取消</el-button>
        <el-button @click="saveDraft">保存</el-button>
        <el-button type="primary" @click="submitRule">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
const XLSX = require('xlsx')

export default {
  name: 'CostDiffRuleAdd',
  data() {
    return {
      isEdit: false,
      sections: {
        basic: true,
        handler: true,
        condition: true,
        supplement: true,
        cc: true
      },
      ruleForm: {
        ruleCode: '',
        diffCategory: '',
        status: '启用',
        handlerRole: '',
        handlers: [],
        conditions: [],
        priority: 1,
        conditionSummary: '',
        ccHandlers: []
      },
      carrierHandlers: [{ carrierCode: '', expressName: '', handler: '' }],
      kaHandlers: [{ brandNames: [], handlers: [], availableHandlers: [] }],
      selectedKaHandlers: [],
      userOptions: ['陈一', '张二', '王五', '赵六', '钱七', '孙八', '周九'],
      brandOptions: ['Nike', 'Adidas', 'Converse', 'Vans', 'Puma', 'New Balance'],
      brandKaMapping: {
        'Nike': ['陈一', '张二'],
        'Adidas': ['王五', '赵六'],
        'Converse': ['钱七'],
        'Vans': ['孙八', '周九'],
        'Puma': ['陈一', '王五'],
        'New Balance': ['张二', '赵六']
      },
      existingRules: [
        { diffCategory: '计费重量差异', priority: 1, status: '启用' },
        { diffCategory: '计费重量差异', priority: 2, status: '启用' },
        { diffCategory: '首重报价差异', priority: 1, status: '启用' },
        { diffCategory: '标准运费差异', priority: 1, status: '启用' },
        { diffCategory: '标准运费差异', priority: 2, status: '禁用' },
        { diffCategory: '目的地省差异', priority: 1, status: '启用' }
      ]
    }
  },
  computed: {
    conditionPreview() {
      if (this.ruleForm.conditions.length === 0) {
        return '暂无'
      }
      const fieldLabels = {
        logisticsChargeWeight: '物流商计费重量',
        bzChargeWeight: 'BZ_计费重量',
        logisticsStandardFreight: '物流商标准运费',
        bzStandardFreight: 'BZ_系统标准运费',
        logisticsDiscountedFreight: '物流商折后运费',
        bzDiscountedFreight: 'BZ_系统折后运费',
        logisticsTotalCost: '物流商总费用',
        bzTotalCost: 'BZ_系统总费用',
        logisticsServiceFee: '物流商服务费',
        bzServiceFee: 'BZ_系统服务费',
        logisticsMinusBzChargeWeight: '物流商计费重量-BZ_计费重量',
        bzMinusLogisticsChargeWeight: 'BZ_计费重量-物流商计费重量'
      }
      const operatorLabels = {
        equals: '等于',
        notEquals: '不等于',
        greaterThan: '大于',
        lessThan: '小于'
      }
      return this.ruleForm.conditions.map((c, i) => {
        const fieldLabel = fieldLabels[c.field] || c.field
        const value = c.value ? ` ${c.valueType === 'field' ? (fieldLabels[c.value] || c.value) : c.value}` : ''
        const logic = i < this.ruleForm.conditions.length - 1 ? ` ${c.logic || 'AND'} ` : ''
        return `(${fieldLabel} ${operatorLabels[c.operator] || c.operator}${value})${logic}`
      }).join('')
    }
  },
  mounted() {
    const editData = this.$route.query.edit
    if (editData) {
      this.isEdit = true
      const data = JSON.parse(decodeURIComponent(editData))
      this.ruleForm = { ...this.ruleForm, ...data }
    }
    this.ruleForm.priority = this.getNextPriority()
  },
  methods: {
    goBack() {
      this.$router.push('/cost-diff-rule')
    },
    toggleSection(section) {
      this.sections[section] = !this.sections[section]
    },
    handleHandlerRoleChange() {
      if (this.ruleForm.handlerRole === '物流商') {
        this.carrierHandlers = [{ carrierCode: '', expressName: '', handler: '' }]
      } else if (this.ruleForm.handlerRole === 'KA') {
        this.kaHandlers = [{ brandNames: [], handlers: [], availableHandlers: [] }]
      }
    },
    addCarrierHandler() {
      this.carrierHandlers.push({ carrierCode: '', expressName: '', handler: '' })
    },
    removeCarrierHandler(index) {
      if (this.carrierHandlers.length > 1) {
        this.carrierHandlers.splice(index, 1)
      }
    },
    addKaHandler() {
      this.kaHandlers.push({ brandNames: [], handlers: [], availableHandlers: [] })
    },
    removeKaHandler(index) {
      if (this.kaHandlers.length > 1) {
        this.kaHandlers.splice(index, 1)
      }
    },
    handleKaSelectionChange(selectedItems) {
      this.selectedKaHandlers = selectedItems
    },
    batchDeleteKaHandlers() {
      if (this.selectedKaHandlers.length === 0) {
        return
      }
      this.$confirm(`确定要删除选中的 ${this.selectedKaHandlers.length} 条记录吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        const indexes = this.selectedKaHandlers.map(item => {
          return this.kaHandlers.indexOf(item)
        }).sort((a, b) => b - a)
        
        indexes.forEach(index => {
          this.kaHandlers.splice(index, 1)
        })
        
        this.selectedKaHandlers = []
        this.$message.success('批量删除成功')
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    handleBrandChange(index, brands) {
      let availableHandlers = []
      brands.forEach(brand => {
        if (this.brandKaMapping[brand]) {
          availableHandlers = [...new Set([...availableHandlers, ...this.brandKaMapping[brand]])]
        }
      })
      this.kaHandlers[index].availableHandlers = availableHandlers.length > 0 ? availableHandlers : this.userOptions
    },
    importKaConfig() {
      this.$refs.kaImportFile.click()
    },
    downloadKaTemplate() {
      const headers = ['品牌名称', '处理人']
      const sampleData = [
        ['Nike, Adidas', '陈一, 张二'],
        ['Converse', '钱七']
      ]
      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sampleData])
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'KA处理人配置模板')
      XLSX.writeFile(workbook, 'KA处理人配置导入模板.xlsx')
    },
    handleKaImport(event) {
      const file = event.target.files[0]
      if (file) {
        this.$message.success('导入成功')
        event.target.value = ''
      }
    },
    exportKaConfig() {
      const data = this.kaHandlers.map(row => ({
        '品牌名称': row.brandNames.join(','),
        '处理人': row.handlers.join(',')
      }))
      const csv = ['品牌名称,处理人', ...data.map(row => `${row['品牌名称']},${row['处理人']}`)].join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'KA处理人配置.csv'
      link.click()
    },
    addCondition() {
      this.ruleForm.conditions.push({
        field: '',
        operator: '',
        valueType: 'field',
        value: '',
        logic: 'AND'
      })
    },
    removeCondition(index) {
      this.ruleForm.conditions.splice(index, 1)
    },
    getNextPriority() {
      return 5
    },
    validateForm() {
      if (!this.ruleForm.diffCategory) {
        this.$message.error('请选择差异原因')
        return false
      }
      if (!this.ruleForm.handlerRole) {
        this.$message.error('请选择差异处理方')
        return false
      }
      if (this.ruleForm.handlerRole === '承运商') {
        for (const row of this.carrierHandlers) {
          if (!row.carrierCode && !row.expressName) {
            this.$message.error('请至少填写承运商编码或快递公司名称')
            return false
          }
          if (!row.handler) {
            this.$message.error('请选择处理人')
            return false
          }
        }
      }
      if (!this.ruleForm.priority) {
        this.$message.error('请输入优先级')
        return false
      }
      const enabledRulesWithSameCategory = this.existingRules.filter(
        r => r.diffCategory === this.ruleForm.diffCategory && r.status === '启用'
      )
      if (enabledRulesWithSameCategory.some(r => r.priority === this.ruleForm.priority)) {
        this.$message.error('同一差异原因下优先级不能重复')
        return false
      }
      return true
    },
    saveDraft() {
      if (!this.validateForm()) return
      this.$message.success('保存成功')
    },
    submitRule() {
      if (!this.validateForm()) return
      this.$message.success('提交成功')
      setTimeout(() => {
        this.goBack()
      }, 1000)
    }
  }
}
</script>

<style scoped>
.cost-diff-rule-add {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.page-header {
  background-color: #fff;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.disabled-input {
  background-color: #f5f7fa !important;
  color: #909399 !important;
}

.form-container {
  padding: 20px;
}

.form-section {
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 16px;
  border: 1px solid #ebeef5;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  cursor: pointer;
  border-bottom: 1px solid #ebeef5;
}

.section-icon {
  color: #409EFF;
  font-weight: bold;
}

.section-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-right: auto;
}

.section-toggle {
  font-size: 12px;
  color: #909399;
}

.required-mark {
  color: #F56C6C;
}

.section-content {
  padding: 16px;
}

.form-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.form-grid .el-form-item {
  margin-bottom: 16px;
}

.carrier-config-section,
.ka-config-section {
  margin-top: 16px;
}

.config-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.config-title {
  font-size: 13px;
  color: #606266;
  padding-left: 8px;
  border-left: 3px solid #409EFF;
}

.config-actions {
  display: flex;
  gap: 12px;
}

.empty-condition {
  padding: 30px;
  text-align: center;
  color: #909399;
}

.condition-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.condition-field,
.condition-operator,
.condition-value,
.condition-logic {
  width: 120px;
}

.condition-value-type {
  width: 100px;
}

.condition-preview {
  margin-top: 16px;
  padding: 12px;
  background-color: #fafafa;
  border-radius: 4px;
}

.preview-label {
  font-size: 13px;
  color: #606266;
}

.preview-content {
  font-size: 13px;
  color: #303133;
}

.tolerance-hint {
  color: #909399;
  font-size: 12px;
  margin-left: 8px;
}

.form-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 14px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ebeef5;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.footer-buttons {
  display: flex;
  gap: 16px;
}

.form-footer .el-button {
  width: 100px;
}

.carrier-config-section,
.ka-config-section {
  width: 100%;
  margin-top: 16px;
}
</style>
